import bibg from "../../../assets/img/bi.webp";

interface Props {
  ketQuaKyTruoc: any;
}
const RenderKetQua = ({ ketQuaKyTruoc }: Props) => {
  const tong =
    Number(ketQuaKyTruoc?.ball1) +
    Number(ketQuaKyTruoc?.ball2) +
    ketQuaKyTruoc?.ball3;

  const render = () => {
    if (tong >= 10) return "LONG, DOUBLE";
    return "SHORT, SINGLE";
  };
  return (
    <div className="px-3 py-2 box-top-1 mt-2 text-center">
      <p
        className="d-flex gap-1 justify-content-center align-items-center"
      >
        <div className="d-flex gap-1 align-items-center">
          <div className="bi">
            <span>{ketQuaKyTruoc?.ball1}</span>
            <img src={bibg} />
          </div>

          <div className="dau">+</div>

          <div className="bi">
            <span>{ketQuaKyTruoc?.ball2}</span>
            <img src={bibg} />
          </div>

          <div className="dau">+</div>

          <div className="bi">
            <span>{ketQuaKyTruoc?.ball3}</span>
            <img src={bibg} />
          </div>
        </div>

        <div className="dau">=</div>

        <div
          className="bi"
        >
          <span>{tong}</span>
          <img src={bibg} />
        </div>
        <span className="fw-bold" style={{ color: "rgb(255, 0, 0)"}}>{render()}</span>
      </p>
    </div>
  );
};

export default RenderKetQua;
